// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SdwR6GLozHlor501OOfV {
  display: flex;
  align-items: center;
}
.SdwR6GLozHlor501OOfV > i {
  padding: 0 0.3em;
  opacity: 0.6;
}
.SdwR6GLozHlor501OOfV > .icon {
  font-size: 1.5em;
  padding: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SdwR6GLozHlor501OOfV`,
	"icon": `icon`
};
export default ___CSS_LOADER_EXPORT___;
